var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowButtonGreenDown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "arrow_button_green_down") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-01-B",
    transform: "translate(-357.000000, -30.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(201.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(10.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "arrow_button_green_down",
    transform: "translate(156.000000, 15.000000) scale(1, -1) translate(-156.000000, -15.000000) translate(146.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    stroke: "#E1E7F0",
    fill: "#FFFFFF",
    cx: 10,
    cy: 10,
    r: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,9.57937933 C12.0004164,9.79065428 11.9166209,9.99338527 11.7671557,10.1427085 L8.90063643,13.0092278 C8.6922723,13.2109331 8.36064143,13.2082407 8.15557967,13.003179 C7.95051791,12.7981172 7.94782554,12.4664863 8.14953087,12.2581222 L10.7750955,9.6325576 C10.7892225,9.61846622 10.797162,9.59933279 10.797162,9.57937933 C10.797162,9.55942587 10.7892225,9.54029243 10.7750955,9.52620105 L8.14953087,6.90063643 C7.94782554,6.6922723 7.95051791,6.36064143 8.15557967,6.15557967 C8.36064143,5.95051791 8.6922723,5.94782554 8.90063643,6.14953087 L11.7671557,9.01605015 C11.9166209,9.16537338 12.0004164,9.36810438 12,9.57937933 L12,9.57937933 Z",
    id: "Path",
    fill: "#00584D",
    fillRule: "nonzero",
    transform: "translate(10.000000, 9.579379) scale(1, -1) rotate(-270.000000) translate(-10.000000, -9.579379) "
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowButtonGreenDown);
export default __webpack_public_path__ + "static/media/arrow_button_green_down.72c748eb8d0b895f248db5e2ae2f67df.svg";
export { ForwardRef as ReactComponent };